import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { omit } from 'lodash';

import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import ProspectForm from '../components/prospect-form-minimal';
import { apiFetch } from '../lib/fetch';
import useUser from '../lib/useUser';
import Layout from '../components/layout';
import { Button } from '../lib/common';

const useStyles = makeStyles({
  loadingCircle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '100px',
  },
  submitBtn: {
    margin: '15px',
  },
  error: {
    fontWeight: 'bold',
    color: 'red',
    margin: '15px',
  },
  gridContainer: {
    width: '100%',
    display: 'flex',
    height: 450,
  },
  ignoreBtn: {
    margin: '15px',
  },
});

const Client = () => {
  const history = useHistory();
  const user = useUser();
  const [client, setClient] = useState({
    firstname: '',
    lastname: '',
    dob: '',
    retirement_age: 65,
    spouse_firstname: '',
    spouse_lastname: '',
    spouse_dob: '',
    spouse_retirement_age: 65,
    addSpouse: false,
  });
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState(null);
  const [configs, setConfigs] = useState(null);
  const classes = useStyles();

  useEffect(async () => {
    const ct = await apiFetch('/clients/config_types');
    setConfigs(ct);
  }, []);

  const handleSave = async () => {
    setSubmitting(true);
    setErr(null);
    if (!client.dob) {
      client.dob = null;
    }
    if (!client.spouse_dob) {
      client.spouse_dob = null;
    }
    const toSave = omit(client, ['addSpouse']);
    try {
      const results = await apiFetch.post(`/users/${user.id}/ip_households`, toSave);
      if (results) {
        history.push(`/clients/${results.id}`);
      } else {
        setSubmitting(false);
      }
    } catch (e) {
      setSubmitting(false);
      setErr(e.content || e);
    }
  };

  const invalid = !client.firstname || !client.lastname;

  return (
    <Layout>
      {configs ? (
        <div>
          <div>
            <Typography variant="h4">Client Personal Information</Typography>
            {err ? (
              <div className={classes.error}>{err.message}</div>
            ) : ''}
            <ProspectForm
              client={client}
              isNew={true}
              update={(c) => {
                setClient({ ...c });
              }}
            />
          </div>
          <div className={classes.submitBtn}>
            <Button
              onClick={handleSave}
              disabled={submitting || (invalid)}
            >
              Save
            </Button>
          </div>
        </div>
      ) : (
        <CircularProgress/>
      )}
    </Layout>
  );
};

export default Client;
